<template>
  <div class="home-box">
    <PageTitle :title="'Activity'"></PageTitle>

    <BoardMeetingAdd v-if="activity === 'BOARD_MEETING'"></BoardMeetingAdd>
    <MonthlyMeeting v-else-if="activity === 'MONTHLY_MEETING'"></MonthlyMeeting>
    <MonthlyMemberships
      v-else-if="activity === 'MONTHLY_MEMBERSHIP'"
    ></MonthlyMemberships>
    <ReportClubActivities
      v-else-if="activity === 'REPORT_CLUB_ACTIVITY'"
    ></ReportClubActivities>
    <PublishNewLatter
      v-else-if="activity === 'PUBLISH_NEWS_LETTER'"
    ></PublishNewLatter>
    <FinancialStatement
      v-else-if="activity === 'FINANCIAL_STATEMENT'"
    ></FinancialStatement>
    <MafContribution
      v-else-if="activity === 'MAF_CONTRIBUTION'"
    ></MafContribution>
    <MjfContribution
      v-else-if="activity === 'MJF_CONTRIBUTION'"
    ></MjfContribution>
    <Trainings v-else-if="activity === 'TRAINING'"></Trainings>
    <Website v-else-if="activity === 'INITIATING_WEBSITE'"></Website>
    <Facebook v-else-if="activity === 'INITIATING_FACEBOOK'"></Facebook>
    <ExtensionNewLionsClub
      v-else-if="activity === 'EXTENSION_NEW_LIONS_CLUB'"
    ></ExtensionNewLionsClub>
    <ExtensionNewLeoClub
      v-else-if="activity === 'EXTENSION_NEW_LEO_CLUB'"
    ></ExtensionNewLeoClub>
    <PresidentExcellenceAwards
      v-else-if="activity === 'APPLY_PRESIDENT_EXCELLENCE_AWARD'"
    ></PresidentExcellenceAwards>
    <LeadersInClubVicinities
      v-else-if="activity === 'LEADER_LIST_CLUB_VICINITY'"
    ></LeadersInClubVicinities>
    <NewClubOfficerWorkshops
      v-else-if="activity === 'PARTICIPATION_NEW_CLUB_OFFICERS_WORKSHOP'"
    ></NewClubOfficerWorkshops>
    <CabinetInstallationCeremony
      v-else-if="activity === 'PARTICIPATION_CABINET_INSTALLATION_CEREMONY'"
    ></CabinetInstallationCeremony>
    <AppointmentBoardClubAuditor
      v-else-if="activity === 'APPOINTMENT_AUDITOR'"
    ></AppointmentBoardClubAuditor>
    <HandingOverClubRecord
      v-else-if="activity === 'HANDING_OVER_CLUB_DETAILS'"
    ></HandingOverClubRecord>
    <HonoringPastPresident
      v-else-if="activity === 'HONORING_PAST_PRESIDENT'"
    ></HonoringPastPresident>
    <DistrictDue v-else-if="activity === 'DISTRICT_DUES'"></DistrictDue>
    <PaymentDistrictDirectory
      v-else-if="activity === 'PAYMENT_DISTRICT_DIRECTORY'"
    ></PaymentDistrictDirectory>
    <PublishingClubDirectory
      v-else-if="activity === 'PUBLISHING_CLUB_DIRECTOR'"
    ></PublishingClubDirectory>
    <RecognitionLionLady
      v-else-if="activity === 'RECOGNITION_LION_LADIES'"
    ></RecognitionLionLady>

    <LadiesGetTogether
      v-else-if="activity === 'LADIES_GET_TOGETHER'"
    ></LadiesGetTogether>

    <FirstZonalAdvisory
      v-else-if="activity === 'FIRST_ZONAL_ADVISORIES'"
    ></FirstZonalAdvisory>

    <RegionActionMeeting
      v-else-if="activity === 'REGION_ACTION_MEETING'"
    ></RegionActionMeeting>

    <AuditedAccount
      v-else-if="activity === 'AUDITED_ACCOUNTS'"
    ></AuditedAccount>

    <GetDateCharter
      v-else-if="activity === 'GET_DATE_CHARTERS'"
    ></GetDateCharter>

    <InternationalDue
      v-else-if="activity === 'INTERNATIONAL_DUES'"
    ></InternationalDue>

    <DistrictGetTogether
      v-else-if="activity === 'DISTRICT_GET_TOGETHER'"
    ></DistrictGetTogether>

    <ZoneChairpersonVisit
      v-else-if="activity === 'ZONE_CHAIRPERSON_VISIT'"
    ></ZoneChairpersonVisit>

    <ReportCepWorkshop
      v-else-if="activity === 'REPORT_CEP_WORKSHOP'"
    ></ReportCepWorkshop>

    <RegionChairpersonVisit
      v-else-if="activity === 'REGION_CHAIRPERSON_VISIT'"
    ></RegionChairpersonVisit>

    <MemberSponsorNight
      v-else-if="activity === 'MEMBER_SPONSOR_NIGHT'"
    ></MemberSponsorNight>

    <SecondZonalAdvisory
      v-else-if="activity === 'SECOND_ZONAL_ADVISORIES'"
    ></SecondZonalAdvisory>

    <MidCourseReviewMeeting
      v-else-if="activity === 'MID_COURSE_REVIEWS'"
    ></MidCourseReviewMeeting>

    <ContributionDistrictFund
      v-else-if="activity === 'CONTRIBUTION_DISTRICT_FUNDS'"
    >
    </ContributionDistrictFund>

    <ParticipationDistrictFund
      v-else-if="activity === 'PARTICIPATION_AT_DISTRICT_FUNDS'"
    ></ParticipationDistrictFund>

    <ViceGovernorVisit
      v-else-if="activity === 'VICE_GOVERNOR_VISITS'"
    ></ViceGovernorVisit>

    <MjfNight v-else-if="activity === 'MJF_NIGHTS'"></MjfNight>

    <DuesSecondHalf
      v-else-if="activity === 'DUES_FOR_SECOND_HALVES'"
    ></DuesSecondHalf>
    <HonoringPastDistrict v-else-if="activity === 'HONORING_OF_PAST_DISTRICTS'">
    </HonoringPastDistrict>
    <NominationCommittee
      v-else-if="activity === 'NOMINATION_COMMITTEES'"
    ></NominationCommittee>
    <NominationElectionCommittee
      v-else-if="activity === 'NOMINATION_ELECTIONS'"
    ></NominationElectionCommittee>
    <DistrictConvention
      v-else-if="activity === 'REGISTERED_FOR_CONVENTIONS'"
    ></DistrictConvention>
    <SubmissionPu v-else-if="activity === 'SUBMISSION_OF_PUS'"></SubmissionPu>
    <ClubFundRasing
      v-else-if="activity === 'CLUB_FUNDS_RASING'"
    ></ClubFundRasing>
    
    <ParticipationDistrictEvents
      v-else-if="activity === 'PARTICIPATION_DISTRICT_EVENTS'"
    ></ParticipationDistrictEvents>

    
  </div>
</template>

<script>
import BoardMeetingAdd from "@/components/activities/forms/BoardMeetingAdd";
import MonthlyMeeting from "@/components/activities/forms/MonthlyMeeting";
import MonthlyMemberships from "@/components/activities/forms/MonthlyMemberships";
import ReportClubActivities from "@/components/activities/forms/ReportClubActivities";
import PublishNewLatter from "@/components/activities/forms/PublishNewLatter";
import FinancialStatement from "@/components/activities/forms/FinancialStatement";
import MafContribution from "@/components/activities/forms/MafContribution";
import MjfContribution from "@/components/activities/forms/MjfContribution";
import Trainings from "@/components/activities/forms/Trainings";
import Website from "@/components/activities/forms/Website";
import Facebook from "@/components/activities/forms/Facebook";
import ExtensionNewLionsClub from "@/components/activities/forms/ExtensionNewLionsClub";
import ExtensionNewLeoClub from "@/components/activities/forms/ExtensionNewLeoClub";
import PresidentExcellenceAwards from "@/components/activities/forms/PresidentExcellenceAwards";
import LeadersInClubVicinities from "@/components/activities/forms/LeadersInClubVicinities";
import NewClubOfficerWorkshops from "@/components/activities/forms/NewClubOfficerWorkshops";
import CabinetInstallationCeremony from "@/components/activities/forms/CabinetInstallationCeremony";
import AppointmentBoardClubAuditor from "@/components/activities/forms/AppointmentBoardClubAuditor";
import HandingOverClubRecord from "@/components/activities/forms/HandingOverClubRecord";
import HonoringPastPresident from "@/components/activities/forms/HonoringPastPresident";
import DistrictDue from "@/components/activities/forms/DistrictDue";
import PaymentDistrictDirectory from "@/components/activities/forms/PaymentDistrictDirectory";
import PublishingClubDirectory from "@/components/activities/forms/PublishingClubDirectory";
import RecognitionLionLady from "@/components/activities/forms/RecognitionLionLady";
import LadiesGetTogether from "@/components/activities/forms/LadiesGetTogether";
import FirstZonalAdvisory from "@/components/activities/forms/FirstZonalAdvisory";
import RegionActionMeeting from "@/components/activities/forms/RegionActionMeeting";
import AuditedAccount from "@/components/activities/forms/AuditedAccount";
import GetDateCharter from "@/components/activities/forms/GetDateCharter";
import InternationalDue from "@/components/activities/forms/InternationalDue";
import DistrictGetTogether from "@/components/activities/forms/DistrictGetTogether";
import ZoneChairpersonVisit from "@/components/activities/forms/ZoneChairpersonVisit";
import ReportCepWorkshop from "@/components/activities/forms/ReportCepWorkshop";
import RegionChairpersonVisit from "@/components/activities/forms/RegionChairpersonVisit";
import MemberSponsorNight from "@/components/activities/forms/MemberSponsorNight";
import SecondZonalAdvisory from "@/components/activities/forms/SecondZonalAdvisory";
import MidCourseReviewMeeting from "@/components/activities/forms/MidCourseReviewMeeting";
import ContributionDistrictFund from "@/components/activities/forms/ContributionDistrictFund";
import ParticipationDistrictFund from "@/components/activities/forms/ParticipationDistrictFund";
import ViceGovernorVisit from "@/components/activities/forms/ViceGovernorVisit";
import MjfNight from "@/components/activities/forms/MjfNight";
import DuesSecondHalf from "@/components/activities/forms/DuesSecondHalf";
import HonoringPastDistrict from "@/components/activities/forms/HonoringPastDistrict";
import NominationCommittee from "@/components/activities/forms/NominationCommittee";
import NominationElectionCommittee from "@/components/activities/forms/NominationElectionCommittee";
import DistrictConvention from "@/components/activities/forms/DistrictConvention";
import SubmissionPu from "@/components/activities/forms/SubmissionPu";
import ClubFundRasing from "@/components/activities/forms/ClubFundRasing";
import ParticipationDistrictEvents from "@/components/activities/forms/ParticipationDistrictEvents";

import PageTitle from "@/components/shared/PageTitle";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "groupSetUpFrom",

  components: {
    BoardMeetingAdd,
    PageTitle,
    MonthlyMeeting,
    MonthlyMemberships,
    ReportClubActivities,
    PublishNewLatter,
    FinancialStatement,
    MafContribution,
    MjfContribution,
    Trainings,
    Website,
    Facebook,
    ExtensionNewLionsClub,
    ExtensionNewLeoClub,
    PresidentExcellenceAwards,
    LeadersInClubVicinities,
    NewClubOfficerWorkshops,
    CabinetInstallationCeremony,
    AppointmentBoardClubAuditor,
    HandingOverClubRecord,
    HonoringPastPresident,
    DistrictDue,
    PaymentDistrictDirectory,
    PublishingClubDirectory,
    RecognitionLionLady,
    LadiesGetTogether,
    FirstZonalAdvisory,
    RegionActionMeeting,
    AuditedAccount,
    GetDateCharter,
    InternationalDue,
    DistrictGetTogether,
    ZoneChairpersonVisit,
    ReportCepWorkshop,
    RegionChairpersonVisit,
    MemberSponsorNight,
    SecondZonalAdvisory,
    MidCourseReviewMeeting,
    ContributionDistrictFund,
    ParticipationDistrictFund,
    ViceGovernorVisit,
    MjfNight,
    DuesSecondHalf,
    HonoringPastDistrict,
    NominationCommittee,
    NominationElectionCommittee,
    DistrictConvention,
    SubmissionPu,
    ClubFundRasing,
    ParticipationDistrictEvents,
  },

  data: () => ({
    loading: false,
    errors: null,
    snackbar: false,
    succesMsg: "",
    activity: null,
    form: {
      name: "",
      exam: "",
      subject: "",
      teacher: localStorage.getItem("teacher_id"),
    },
  }),

  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.activity = this.$route.params.key;
  },

  computed: {
    ...mapGetters({}),
  },

  methods: {},
};
</script>
<style>
.group-setup-form .v-card {
  box-shadow: none;
  border-radius: 10px;
}
.group-setup-form .v-card__actions {
  text-align: right;
  display: block;
}
</style>
